import FormLabel from "@components/shared/FormLabel";
import React from "react";
import { InputHTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

export interface CustomInputFieldProps<T> extends InputHTMLAttributes<T> {
  leadingIcon?: React.ReactNode;
  trailingIcon?: React.ReactNode;
  enableDarkMode?: boolean;
  label?: string;
  inputClassName?: string;
  errorMessage?: string;
}

const CustomInputField = React.forwardRef(
  (
    {
      leadingIcon,
      enableDarkMode,
      trailingIcon,
      label,
      className,
      inputClassName,
      errorMessage,
      ...props
    }: CustomInputFieldProps<HTMLInputElement>,
    ref: React.ForwardedRef<HTMLInputElement>,
  ) => {
    const darkMode = enableDarkMode ?? true;

    return (
      <div className={twMerge(`flex w-full flex-col`, className)}>
        {label && <FormLabel label={label} />}
        <div className="relative mt-1 rounded-md shadow-sm disabled:shadow-none">
          {leadingIcon && (
            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-lg text-gray-400">
              {leadingIcon}
            </div>
          )}
          <input
            className={twMerge(
              "block w-full rounded-md border-[1px] border-borderColor bg-lightCard bg-opacity-75 py-3 text-xs outline-none focus:border-accentColor disabled:border-0",
              leadingIcon ? "pl-10 pr-4" : "px-2",
              darkMode &&
              "text-gray-700 dark:border-darkBorderColor dark:bg-darkCard dark:text-gray-200 dark:focus:border-darkAccentColor",
              inputClassName,
            )}
            type="text"
            ref={ref}
            {...props}
            onFocus={props.onFocus}
          />

          {trailingIcon && (
            <div
              className={`absolute inset-y-0 flex items-center pr-3 text-lg text-gray-400 ${props.type === "date" ? "right-7" : "right-0"
                }`}
            >
              {trailingIcon}
            </div>
          )}
        </div>
        {errorMessage && (
          <span className="input-field-error">{errorMessage}</span>
        )}
      </div>
    );
  },
);

CustomInputField.displayName = "CustomInputField";

export default CustomInputField;
